import React, {FC, useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {MaybeString} from "../../types/Maybe";

interface Props {
    label: string | React.ReactElement;
    value: MaybeString;
    onChange?: (newValue: MaybeString) => void;
    visible?: boolean;
    required?: boolean;
    labelClass?: string;
    fieldClass?: string;
    groupClass?: string;
    options: { value: MaybeString; label: string }[];
}

const SelectInputField: FC<Props> = (props) => {
    const [value, setValue] = useState<MaybeString>(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    function handleChange(newValue: MaybeString) {
        setValue(newValue);
        props.onChange && props.onChange(newValue);
    }

    if (props.visible === false) {
        return null;
    }

    return (
        <Form.Group className={props.groupClass}>
            {
                props.label &&
                <Form.Label className={props.labelClass}>{props.label}
                    {
                        props.required && <span className={"text-danger"}>*</span>
                    }
                </Form.Label>
            }
            <Form.Select
                required={props.required}
                disabled={!props.onChange}
                className={props.fieldClass}
                value={value || ""}
                onChange={event => handleChange(event.target.value)}>
                {
                    props.options.map(option => (
                        <option key={option.value ?? ""} value={option.value ?? ""}>{option.label}</option>
                    ))
                }
            </Form.Select>
        </Form.Group>
    );
}

export default SelectInputField;
